export const sleep = (ms: number): Promise<void> =>
  new Promise((s) => setTimeout(s, ms))
